import semver from 'semver';
import { extractAssetAgnosticProperties } from '~/utils/assets';
import { getGAKey } from '~/utils/types';

export function mergeIncompleteVersion(state, assetVersion) {
  const assetPath = getGAKey(assetVersion);
  const assetVersions = (state.data[assetPath] || {}).versions || {};

  if (
    assetVersions[assetVersion.version] &&
    assetVersions[assetVersion.version].isCompleted &&
    !assetVersions[assetVersion.version].isMinorVersionTransition
  ) {
    return state;
  }

  return mergeVersion(state, assetVersion);
}

export function mergeVersion(state, assetVersion) {
  const assetPath = getGAKey(assetVersion);
  const assetProperties = extractAssetAgnosticProperties(assetVersion);
  const currentAssetVersions = (state.data[assetPath] || {}).versions || {};

  const newAssetVersion = {
    ...currentAssetVersions[assetVersion.version],
    ...assetVersion
  };

  const newAssetVersions = {
    ...currentAssetVersions,
    [assetVersion.version]: {
      ...newAssetVersion,
      files: newAssetVersion.files || [],
      labels: newAssetVersion.labels || [],
      organization:
        newAssetVersion.organization ||
        (newAssetVersion.organizationId && {
          id: newAssetVersion.organizationId
        })
    }
  };

  const lastVersion = Object.keys(newAssetVersions)
    .filter((version) => !newAssetVersions[version].isDeleted)
    .sort((v1, v2) => semver.rcompare(v1, v2))[0];

  return {
    ...state,
    data: {
      ...state.data,
      [assetPath]: {
        ...state.data[assetPath],
        ...assetProperties,
        lastVersion,
        versions: newAssetVersions
      }
    }
  };
}

export function findAssetListItem(asset, assetList) {
  return assetList.find(
    (currentItem) =>
      currentItem.groupId === asset.groupId &&
      currentItem.assetId === asset.assetId
  );
}

export function buildAssetListItem(asset, highlight, batchNumber) {
  return {
    replacedOutsideBatch: false,
    groupId: asset.groupId,
    assetId: asset.assetId,
    version: asset.version,
    score: asset.score,
    batchNumber,
    highlight
  };
}

function pickNewestVersion(newItem, currentItem) {
  if (semver.gt(newItem.version, currentItem.version)) {
    return [newItem, currentItem];
  }

  return [currentItem, newItem];
}

export function mergeAssetListItems(newItem, currentItem) {
  const [selectedItem, discardedItem] = pickNewestVersion(newItem, currentItem);
  const discardedItemScores = discardedItem.highlight.scores;
  const selectedItemScores = selectedItem.highlight.scores;

  return {
    ...selectedItem,
    replacedOutsideBatch:
      currentItem.replacedOutsideBatch ||
      selectedItem.batchNumber !== currentItem.batchNumber,
    highlight: {
      ...selectedItem.highlight,
      scores: {
        ...selectedItemScores,
        count: discardedItemScores.count + selectedItemScores.count,
        versions: {
          ...discardedItemScores.versions,
          ...selectedItemScores.versions
        }
      }
    }
  };
}
